// Theme configuration for the app

const theme = {
  colors: {
    // Primary colors
    primary: '#7B2CBF',     // deep purple
    secondary: '#9D4EDD',   // mid purple
    accent: '#C77DFF',      // light purple
    
    // Background colors
    background: {
      dark: '#10002B',      // very dark purple (almost black)
      main: '#240046',      // dark purple
      light: '#3C096C',     // medium purple
      card: '#300558',      // card background
    },
    
    // Text colors
    text: {
      primary: '#FFFFFF',
      secondary: '#E0AAFF',
      muted: '#BF9BDE',
    },
    
    // Status colors
    status: {
      success: '#00F5D4',
      warning: '#FFD166',
      error: '#FF5E5B',
      info: '#38B6FF',
    },
    
    // Border and shadow
    border: '#5A189A',
    shadow: 'rgba(0, 0, 0, 0.4)',
  },
  
  // Typography
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    md: '1rem',       // 16px
    lg: '1.25rem',    // 20px
    xl: '1.5rem',     // 24px
    xxl: '2rem',      // 32px
  },
  
  // Spacing
  spacing: {
    xs: '0.25rem',    // 4px
    sm: '0.5rem',     // 8px
    md: '1rem',       // 16px
    lg: '1.5rem',     // 24px
    xl: '2rem',       // 32px
    xxl: '3rem',      // 48px
  },
  
  // Borders and Rounded Corners
  borderRadius: {
    sm: '0.25rem',    // 4px
    md: '0.5rem',     // 8px
    lg: '1rem',       // 16px
    xl: '2rem',       // 32px
    circle: '50%',
  },
  
  // Shadows
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.3)',
    md: '0 4px 8px rgba(0, 0, 0, 0.3)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.3)',
    glow: '0 0 8px',
  },
  
  // Transitions
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
  
  // Breakpoints for responsive design
  breakpoints: {
    xs: '400px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
};

export default theme; 